import { Box, Typography } from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { fetchCustomerReportService } from "../../../services/reportService";

function CustomerReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customer, setCustomers] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleFilter = () => {
    fetchCustomers();
    // Fetch or filter customer based on fromDate and toDate
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchCustomers = async () => {
    try {
      const getCustomers = await fetchCustomerReportService(
        fromDate,
        toDate,
        page,
        rowsPerPage
      );
      setCustomers(getCustomers?.customers);
      setExcelData(getCustomers?.excelData);  // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [page, rowsPerPage]);

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Customer Report</Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#f7f7ff",
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  label="From Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ mr: 2 }}
                />
                <TextField
                  label="To Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ mr: 2 }}
                />
                <Button
                  variant="contained"
                  onClick={handleFilter}
                  sx={{ backgroundColor: "#7366ff", color: "#fff" }}
                >
                  Filter
                </Button>
              </div>
            </Paper>
            <Box sx={{ mt: 2 }}>
              {" "}
              <TableContainer>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ color: "#5252ff" }}>SL.NO</TableCell>
                      <TableCell sx={{ color: "#5252ff" }}>
                        CUSTOMER NAME
                      </TableCell>
                      <TableCell sx={{ color: "#5252ff" }}>
                        PHONE NUMBER
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customer?.length > 0 ? (
                      customer
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={row.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{row?.userName}</TableCell>
                            <TableCell>
                              {row?.primaryPhone?.contactValue}
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} style={{ textAlign: "center" }}>
                          No customer available in table
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={customer.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Show"
              />
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default CustomerReport;
